import Icon from '@atoms/Icon/Icon';
import Tag from '@atoms/Tag/Tag';
import { IListingFilter } from '@models/IListingFilter';
import { IStoredFilters } from '@models/IStoredFilters';
import IconSizeEnum from '@models/enums/IconSizeEnum';
import TagTypesEnum from '@models/enums/TagTypesEnum';

interface Props {
  filters: IListingFilter[];
  values: IStoredFilters;
  setFieldValue: (groupKey: string, filters: string[]) => void;
}

type FiltersArray = [string, string, string][];

// The reason for the complexity here is really because the values object contained in the Formik state does not have any
// reference to the labels for each filter, and so we have to "re-attach" these labels to the tags

const ContentFilterTags = ({
  values = {},
  filters = [],
  setFieldValue,
}: Props) => {
  // Reduce the filter Group keys down to an Array of
  //  [[group 1,filter 1, Label],[group 1, filter 2, Label],[group 2, filter 2, Label]] - 1 array element per Tag displayed
  const mappedArray = Object.keys(values).reduce((accumulator, groupKey) => {
    // Find Group in filters which we are currently mapping through
    const currentFilterGroup =
      filters.find((filterGroup) => filterGroup.key === groupKey) || null;

    // This is an Array from our stored filters ['98','420','69']
    const filtersArray: FiltersArray = values[groupKey]!.filter(
      (filterKey) => !!filterKey
    ).map((filterKey) => {
      // Find filter which we are currently returning and get its label
      const currentFilter =
        currentFilterGroup?.values.find((filter) => filter.key === filterKey) ||
        null;
      return [groupKey, filterKey, currentFilter?.label || ''];
    });
    return filtersArray ? accumulator.concat(filtersArray) : accumulator;
  }, [] as FiltersArray);

  return (
    <>
      {mappedArray
        .filter(([, , label]) => !!label)
        .map(([groupKey, filterKey, label], index) => (
          <Tag
            key={`${filterKey}-filter-tag`}
            tagType={TagTypesEnum.Primary}
            onClick={() =>
              setFieldValue(
                groupKey,
                values[groupKey]!.filter(
                  (currentKey) => currentKey !== filterKey
                )
              )
            }
            dataTestId={`Content-Filter-Tag-${index}`}
          >
            {label}
            <Icon
              name="close"
              colorClassName="white"
              className="-mr-1 ml-1"
              size={IconSizeEnum.md}
            />
          </Tag>
        ))}
    </>
  );
};

export default ContentFilterTags;
